import { Box, Flex } from "styled-system/jsx";
import { forwardRef, ReactNode } from "react";

interface AppLayoutProps {
  sidebar: ReactNode;
  content: ReactNode;
}

export const AppLayout = forwardRef<HTMLDivElement, AppLayoutProps>(
  ({ sidebar, content }, ref) => (
    <Flex w={"full"} h={"full"} overflowY={"auto"}>
      <Flex
        bg={"bg.wa.lightest"}
        borderRightWidth={"1px"}
        borderRightColor={"border.light"}
        shrink={0}
      >
        <Box pt={"1000"} pb="100" px={"600"} overflowY="auto">
          {sidebar}
        </Box>
      </Flex>
      <Flex bg={"bg.wa.light"} grow={1}>
        <Box
          ref={ref}
          py={"200"}
          px={"60px"}
          overflowY="auto"
          w={"full"}
          position="relative"
          id="app-layout__main-content"
        >
          <Box maxW={"1100px"} py={"800"}>
            {content}
          </Box>
        </Box>
      </Flex>
    </Flex>
  ),
);
